module.exports = __webpack_public_path__ + "static/media/LOGOS-07.edd5e11b.svg";